import React, { useState } from 'react';
import axios from 'axios';
import './PharmacyVerificationForm.css'; // Create this CSS file for styling

const PharmacyVerificationForm = () => {
  const [licenseNumber, setLicenseNumber] = useState('');
  const [cacNumber, setCacNumber] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const token = localStorage.getItem('access_token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await axios.post(
        'http://127.0.0.1:8000/users/pharmacies/verify',
        {
          license_number: licenseNumber,
          cac_number: cacNumber
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );

      setSuccess(response.data.message || 'Verification request submitted.');
      setLicenseNumber('');
      setCacNumber('');
    } catch (err) {
      const msg = err?.response?.data?.detail || 'Submission failed.';
      setError(msg);
    }
  };

  return (
    <div className="verify-form-container">
      <h3>Pharmacy Verification</h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="License Number"
          value={licenseNumber}
          onChange={(e) => setLicenseNumber(e.target.value)}
          required
        />
        <input
          type="text"
          placeholder="CAC Number"
          value={cacNumber}
          onChange={(e) => setCacNumber(e.target.value)}
          required
        />
        <button type="submit">Submit Verification</button>
      </form>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}
    </div>
  );
};

export default PharmacyVerificationForm;
